"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clamp = void 0;
function clamp(value, min, max) {
    const clampMin = typeof min === "number" ? Math.max(value, min) : value;
    return typeof max === "number" ? Math.min(clampMin, max) : clampMin;
}
exports.clamp = clamp;
